<div class="date-picker">
  <mat-form-field>
    <mat-label *ngIf="label">{{ label }}</mat-label>
    <input
      (blur)="onControlTouched()"
      (change)="onValueChanged($event)"
      [autocomplete]="autocomplete"
      [formControl]="control"
      [id]="inputId"
      [inputMask]="dateInputMask"
      [readonly]="isDisabled"
      matInput
      type="text"
    />
    <input
      (blur)="onControlTouched()"
      (dateChange)="onDateChangedViaDatePicker($event)"
      [id]="inputId + '-picker'"
      [matDatepicker]="picker"
      [readonly]="isDisabled"
      autocomplete="off"
      type="hidden"
    />
    <mat-datepicker-toggle [for]="picker" matSuffix>
      <ui-svg-icon
        class="date-picker__icon"
        iconClassName="icon-compliance--calendar"
        matDatepickerToggleIcon
        svgId="calendar"
      ></ui-svg-icon>
    </mat-datepicker-toggle>
    <mat-datepicker
      #picker
      (monthSelected)="onMonthChanged($event)"
      [disabled]="isDisabled"
      [startAt]="control.value"
      [startView]="format === 'MM/YYYY' ? 'multi-year' : 'month'"
    ></mat-datepicker>
    <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
    <mat-error *ngIf="control.hasError('maxDate')">
      Date must be current date or in the past
    </mat-error>
  </mat-form-field>
</div>
